<template>
    <el-table
        v-if="!loading"
        :data="list" 
        border 
        :height="table_height"
        row-key="id" 
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}" 
        :header-cell-style="{background: '#f3faff'}"
        :summary-method="getSummaries" 
        show-summary
    >
        <el-table-column prop="name" label="地区" width="180" expand></el-table-column>
        <el-table-column prop="customer_num" label="客户总数"></el-table-column>
        <el-table-column prop="total_amount" label="销售额"></el-table-column>
        <el-table-column prop="total_performance_amount" label="新增业绩"></el-table-column>
        <el-table-column prop="order_num" label="订单数"></el-table-column>
        <el-table-column prop="year_svg_price" label="年均价"></el-table-column>
        <el-table-column prop="last_total_performance_amount" label="新增业绩同比"></el-table-column>
        <el-table-column prop="performance_ratio" label="新增业绩年增长">
            <template slot-scope="scope">
                {{ scope.row.performance_ratio }}%
            </template>
        </el-table-column>
        <el-table-column prop="last_order_num" label="订单同比"></el-table-column>
        <el-table-column prop="order_num_ratio" label="订单年增长">
            <template slot-scope="scope">
                {{ scope.row.order_num_ratio }}%
            </template>
        </el-table-column>
        <el-table-column prop="last_year_svg_price" label="年均价同比"></el-table-column>
        <el-table-column prop="year_svg_ratio" label="年均价增长">
            <template slot-scope="scope">
                {{ scope.row.year_svg_ratio }}%
            </template>
        </el-table-column>
    </el-table>
</template>
  
<script>
import OrderCount from "~/services/OrderCount";

export default {
    props:{
        params:{
            type: Object,
            required: true,
        },
        table_height:{
            type: String,
            default: '585px',
        }
    },
    data() {
        return {
            loading: false,
            list: [],
        };
    },
    created(){
        this.getList(this.params);
    },
    mounted() {
        
    },
    methods: {
        getList(params) {
            // console.log('创建地区表格：', this.params);
            this.loading = true;
            OrderCount.getAreaList(params).then((res) => {
                if (res.code == 0) {
                    this.list = res.data;
                }
                this.loading = false;
            })
            .catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                // 第一列不计算合计，显示自定义的文字内容
                if (index === 0) {
                sums.push('合计：');
                return;
                }
                // 初始化合计值为0
                let sum = 0;
                // 遍历数据，累加顶级行的值
                data.forEach(item => {
                // 累加当前项的值，注意转换为数字
                sum += Number(item[column.property]);
                });
                // 如果所有值都是数字，则显示合计结果，否则显示'-'
                if (!isNaN(sum)) {
                sums.push(Math.round(sum * 100) / 100); // 保留两位小数
                } else {
                sums.push('--');
                }
            });
            return sums
        }
    },
};
</script>
  
<style>
/* 在这里添加样式 */
</style>
  


// WEBPACK FOOTER //
// src/views/count/table/area.vue